import React, { useEffect, useState } from "react";
import nom35SecIAnalyticsApi from "../../api/nom35SecIAnalyticsApi";
import ageRanges from "../../data/ageRanges";
import biologicalSexList from "../../data/biologicalSex";
import Nom035SummaryChart from "../../components/analytics/Nom035SummaryChart";
import styles from "./Nom035AnalyticsPage.module.css";

export default function Nom035SecIAnalyticsGlobalPage() {
  const [totalResponses, setTotalResponses] = useState(null);

  const filterConfigs = [
    { name: "ageRange", label: "Rango de edad", options: ageRanges },
    { name: "biologicalSex", label: "Sexo biológico", options: biologicalSexList },
  ];

  useEffect(() => {
    (async () => {
      try {
        const { totalResponses } = await nom35SecIAnalyticsApi.getResponsesCountGlobal();
        setTotalResponses(totalResponses);
      } catch (err) {
        console.error("Error obteniendo total global de encuestados Nom035 Guia I:", err);
      }
    })();
  }, []);

  return (
    <div className={styles.page}>
      <header className={styles.header}>
        <h2 className={styles.title}>Analítica Nom035 Guia I</h2>

        {totalResponses !== null && (
          <div className={styles.totalResponses}>
            <span className={styles.totalLabel}>Total de encuestados:</span>
            <span className={styles.totalCount}>{totalResponses}</span>
          </div>
        )}
      </header>

      <section className={styles.section}>
        <h3 className={styles.sectionTitle}>
          Nom035 Guia I - Acontecimientos Traumáticos Severos
        </h3>
        <div className={styles.fullWidth}>
          <Nom035SummaryChart
            clinical
            title="Resumen clínico (Guía I)"
            filterConfigs={filterConfigs}
            analyticsApi={nom35SecIAnalyticsApi}
            chartIdPrefix="nom035-seci"
          />
        </div>
      </section>
    </div>
  );
}
